import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider, Helmet } from "react-helmet-async";
import App from "./App.jsx";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext.jsx";
import { ModalProvider } from "./context/ModalContext";

// Force light mode
document.documentElement.classList.remove("dark");

// Prevent Android forced dark mode
const metaThemeColor = document.createElement("meta");
metaThemeColor.name = "theme-color";
metaThemeColor.content = "#ffffff";
document.head.appendChild(metaThemeColor);

const metaColorScheme = document.createElement("meta");
metaColorScheme.name = "color-scheme";
metaColorScheme.content = "light only";
document.head.appendChild(metaColorScheme);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename="/">
        <AlertProvider>
          <AuthProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </AuthProvider>
        </AlertProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);
